import { Funnel } from '@marketing-and-funnels/funnel-template';
import { wealthPlanConfig } from '../config/funnel-config';
import { ErrorBoundary } from '../components/ErrorBoundary';

const Index = () => {
  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-slate-900">
        <Funnel config={wealthPlanConfig} />
        
        {/* Meta Compliance Disclaimer */}
        <div className="mt-12 md:mt-16 pt-8 pb-8 border-t border-slate-600 bg-slate-900">
          <div className="container mx-auto px-4 max-w-4xl">
            <h3 className="text-amber-400 font-bold text-sm md:text-base mb-3">Disclaimer</h3>
            <p className="text-xs md:text-sm text-slate-400 leading-relaxed">
              This is a promotional communication for educational purposes only and does not constitute investment, tax, or legal advice, nor a recommendation or guarantee of results. The information provided is general in nature and may not be suitable for your specific financial situation. High net worth individuals and business owners should consult with qualified tax, legal, and financial professionals regarding their specific circumstances, including but not limited to corporate tax planning, wealth management strategies, and estate planning considerations.
              <br /><br />
              Past performance is not indicative of future results. Any strategies discussed may not be appropriate for all individuals and may involve risk. Tax laws and regulations are subject to change and may vary by jurisdiction.
              <br /><br />
              <strong className="text-amber-400/90">Northgate Financial</strong> provides financial education, wealth planning resources, and advisory services to help high net worth individuals and business owners optimize their financial strategies and access trapped corporate capital tax-efficiently.
            </p>
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default Index;
